/**
 * Agreement Profits
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageAgreementProfitsComponent,
  AsyncManagePaymentsComponent,
  AsyncManagePaymentsReportComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageAgreementProfitsComponent}
      />
      <Route
        path={`${match.url}/payments`}
        component={AsyncManagePaymentsComponent}
      />
      <Route
        path={`${match.url}/payments-report`}
        component={AsyncManagePaymentsReportComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
